<template>
  <div>
    <v-card class="card-border mt-2">
      <v-card-text>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :search="table.search"
          :loading="loading"
        >
          <template v-slot:top>
            <v-row dense>
              <v-col cols="12" sm="12">
                <v-btn fab x-small depressed @click="listPapeis()"><v-icon>mdi-refresh</v-icon></v-btn>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  v-model="table.search"
                  placeholder="Buscar..."
                  prepend-inner-icon="mdi-magnify"
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.dataCadastro="{ item }">
            {{ $functions.formatDateFirebase(item.dataCadastro.seconds) }}
          </template>
          <template v-slot:item.ativo="{ item }">
            <v-btn color="transparent" small fab depressed>
              <v-icon :color="item.ativo ? 'green' : 'red'">
                {{ item.ativo ? 'mdi-check' : 'mdi-close' }}
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip v-if="$ability.can('Editar', 'Papeis') || getPapel == 'Administrador'" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="transparent"
                  v-on="on"
                  small
                  fab
                  depressed
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              Editar Nome
            </v-tooltip>
            <v-tooltip v-if="$ability.can('Acessos', 'Papeis') || getPapel == 'Administrador'" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="transparent"
                  v-on="on"
                  small
                  fab
                  depressed
                  @click="$refs.DialogDefineAcessos.show(true, item.id)"
                >
                  <v-icon>mdi-shield-key</v-icon>
                </v-btn>
              </template>
              Definir Acessos
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-btn
      v-if="$ability.can('Adicionar', 'Papeis') || getPapel == 'Administrador'"
      bottom
      color="teal"
      title="Novo Papel"
      dark
      fab
      fixed
      right
      @click="$refs.DialogNovoPapel.show()"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <DialogNovoPapel ref="DialogNovoPapel" @salvar="listPapeis()" />
    <DialogDefineAcessos ref="DialogDefineAcessos" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Papeis from '@/services/papeis'

export default {
  name: 'Papeis',

  components: {
    DialogNovoPapel: () => import('./components/DialogNovoPapel'),
    DialogDefineAcessos: () => import('./components/DialogDefineAcessos')
  },

  data() {
    return {
      area: 'papeis',
      loading: false,

      table: {
        search: '',

        headers: [
          {
            text: 'Nome',
            value: 'nome'
          },{
            text: 'Dt. Cadastro',
            value: 'dataCadastro'
          },{
            text: 'Ativo',
            value: 'ativo'
          },{
            text: '',
            value: 'actions'
          }
        ],

        data: []
      }
    }
  },

  computed: {
    ...mapGetters('auth', ['getPapel']),
  },

  methods: {
    async listPapeis() {
      try {
        this.loading = true
        this.table.data = []
        let papeis = await new Papeis().list()
        this.table.data = papeis
      } catch(error) {
        console.error(error)
        this.$alert.error(error)
      }finally{
        this.loading = false
      }
    }
  },

  mounted() {
    this.listPapeis()
  }
}
</script>
